import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import Button from '../../../components/base/Button';
import { Star, Clock, Users, MapPin, CheckCircle, Heart } from 'lucide-react';

const coupleActivities = [
  {
    id: 3,
    title: "Petit-déjeuner avec Girafes",
    location: "Abu Dhabi",
    price: "508.20",
    originalPrice: "580.00",
    duration: "3 heures",
    groupSize: "Session de 4 personnes",
    rating: 5.0,
    reviews: 456,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2023/08/breakfast-with-the-girrafe-dinner-with-elephant-dubai-holidays-vacances-a-dubai.jpeg",
    badge: "Exclusif",
    highlights: ["Expérience unique", "Petit-déjeuner gourmet", "Photos incluses", "Transport privé"],
    description: "Moment romantique inoubliable avec un petit-déjeuner en tête-à-tête avec les girafes. Expérience exclusive et intime dans un cadre exceptionnel."
  },
  {
    id: 7,
    title: "Vol en Hélicoptère Dubai",
    location: "Dubai Marina",
    price: "245.00",
    originalPrice: "295.00",
    duration: "25 minutes",
    groupSize: "1-3 personnes",
    rating: 5.0,
    reviews: 623,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/11/jetski-3.jpg",
    badge: "Luxe",
    highlights: ["Vue panoramique", "Palm Jumeirah", "Burj Al Arab", "Photos incluses"],
    description: "Survolez Dubaï en hélicoptère pour une expérience romantique unique. Vue à 360° sur les monuments emblématiques de la ville."
  },
  {
    id: 11,
    title: "Dîner Croisière Dhow",
    location: "Dubai Creek",
    price: "68.90",
    originalPrice: "85.00",
    duration: "2 heures",
    groupSize: "Groupe",
    rating: 4.7,
    reviews: 1892,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/safari-dubai-desert-.jpg.webp",
    badge: "Romantique",
    highlights: ["Dîner buffet", "Spectacle traditionnel", "Vue sur la ville", "Boissons incluses"],
    description: "Dîner romantique à bord d'un dhow traditionnel sur Dubai Creek. Ambiance feutrée, cuisine raffinée et vue sur la skyline illuminée."
  }
];

export default function CoupleActivitiesPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-6 pb-8 bg-gradient-to-r from-pink-600 to-rose-600 text-white relative">
        <div className="absolute inset-0 bg-[url('https://mesvacancesadubai.com/wp-content/uploads/2023/08/breakfast-with-the-girrafe-dinner-with-elephant-dubai-holidays-vacances-a-dubai.jpeg')] bg-cover bg-center opacity-30"></div>
        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <h1 className="text-4xl lg:text-5xl font-bold mb-2">Activités en Couple</h1>
          <p className="text-lg text-pink-50 max-w-2xl">Créez des souvenirs inoubliables à deux</p>
        </div>
      </section>

      {/* Activities */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {coupleActivities.map((activity) => (
              <div key={activity.id} className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group">
                <div className="relative overflow-hidden">
                  <img
                    src={activity.image}
                    alt={activity.title}
                    className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-pink-600 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center gap-1">
                      <Heart size={14} fill="currentColor" />
                      {activity.badge}
                    </span>
                  </div>
                  <div className="absolute bottom-4 right-4 bg-white/95 backdrop-blur-sm rounded-lg px-3 py-2">
                    <div className="text-right">
                      <div className="text-lg font-bold text-pink-600">€{activity.price}</div>
                      <div className="text-sm text-gray-500 line-through">€{activity.originalPrice}</div>
                    </div>
                  </div>
                </div>

                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center space-x-1">
                      <Star className="text-amber-400 fill-current" size={16} />
                      <span className="font-semibold text-gray-900">{activity.rating}</span>
                      <span className="text-gray-500 text-sm">({activity.reviews} avis)</span>
                    </div>
                    <div className="flex items-center text-gray-500 text-sm">
                      <MapPin size={14} className="mr-1" />
                      {activity.location}
                    </div>
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-pink-600 transition-colors">
                    {activity.title}
                  </h3>

                  <p className="text-gray-600 text-sm mb-4">{activity.description}</p>

                  <div className="flex items-center justify-between text-sm text-gray-600 mb-4">
                    <div className="flex items-center">
                      <Clock size={14} className="mr-1" />
                      {activity.duration}
                    </div>
                    <div className="flex items-center">
                      <Users size={14} className="mr-1" />
                      {activity.groupSize}
                    </div>
                  </div>

                  <div className="mb-6">
                    <div className="flex flex-wrap gap-1">
                      {activity.highlights.map((highlight, index) => (
                        <span key={index} className="bg-pink-50 text-pink-700 px-2 py-1 rounded text-xs">
                          <CheckCircle size={12} className="inline mr-1" />
                          {highlight}
                        </span>
                      ))}
                    </div>
                  </div>

                  <Button className="w-full text-sm py-2">
                    Réserver maintenant
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

